import { useInteractionStore } from '../../stores/interactionStore';
import { useMediaStore } from '../../stores/mediaStore';
import { Modal } from '../../components/Modal';
import { ArcadeModal } from './ArcadeModal';
import { BoardGameModal } from './BoardGameModal';
import { CalendarModal } from './CalendarModal';
import { ImageObjectModal } from './ImageObjectModal';
import { PictureModal } from './PictureModal';
import { StickyboardModal } from './StickyboardModal';
import { WhiteboardModal } from './WhiteboardModal';
import { YouTubeModal } from './YouTubeModal';

/** Oeffnet je nach Objekttyp das passende Modal. */
export function ObjectModalHost() {
  const openObject = useInteractionStore((s) => s.openObject);
  const close = useInteractionStore((s) => s.closeInteraction);
  const peers = useMediaStore((s) => s.peers);

  if (!openObject) return null;

  switch (openObject.type) {
    case 'whiteboard':
      return <WhiteboardModal object={openObject} onClose={close} />;
    case 'stickyboard':
      return <StickyboardModal object={openObject} onClose={close} />;
    case 'youtube':
      return <YouTubeModal object={openObject} onClose={close} />;
    case 'picture':
      return <PictureModal object={openObject} onClose={close} />;
    case 'fridge':
    case 'coffee':
      return <ImageObjectModal object={openObject} onClose={close} />;
    case 'calendar':
      return <CalendarModal onClose={close} />;
    case 'arcade':
      return <ArcadeModal onClose={close} />;
    case 'boardgame':
      return <BoardGameModal object={openObject} onClose={close} />;
    case 'screen': {
      const sharing = Object.values(peers).filter((p) => p.streams.screen);
      return (
        <Modal title="Bildschirm-Bereich" onClose={close}>
          {sharing.length === 0 ? (
            <p>
              Gerade teilt niemand in deiner Nähe einen Bildschirm. Starte selbst eine Übertragung über den
              🖥️-Button in der Leiste unten.
            </p>
          ) : (
            <p>
              {sharing.map((p) => p.displayName).join(', ')} teilt gerade — das Fenster schwebt über dem Avatar
              und lässt sich per Klick vergrößern.
            </p>
          )}
        </Modal>
      );
    }
    default:
      return null;
  }
}
